import type { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { BulkResizer } from "components/modules/Editors/BulkResizer/BulkResizer";
import Head from "next/head";
import { commonLanguageFiles } from "client/config";
import { LanguageProvider } from "client/contexts/LanguageProvider";
import { translateFunc } from "client/utils/translateFunc";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";

const BulkResizeEditor = () => {
    return (
        <>
            <Head>
                <title>{translateFunc("page-title")}</title>
            </Head>
            <ReduxProvider>
                <BulkResizer />
            </ReduxProvider>
        </>
    );
};

const files = ["bulk-resize-editor", "single-resizer-editor", "uploader", ...commonLanguageFiles];

const LanguageWrapper = () => (
    <LanguageProvider files={files}>
        <BulkResizeEditor />
    </LanguageProvider>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale ?? "", files)),
    },
});

export default LanguageWrapper;
